import styled from 'styled-components';

export const Background = styled.div`
  background: ${({ theme }) => theme.colors.functional.darkestGray};
  padding-top: 80px;
  text-align: center;
  color: ${({ theme }) => theme.colors.functional.white};
`;

export const Hero = styled.section`
  background: ${({ theme }) => theme.colors.primary.main};
  padding: 64px 0;
  color: ${({ theme }) => theme.colors.white};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  padding: 5rem 0;
  a {
    display: block;
    position: relative;
    margin: 2rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    img {
      max-width: 90%;
    }
  }
`;
